{"schemaVersion":1,"release":{"version":"1.1.20","build":182,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.20-182.dmg","sha256":"929c99c93e051ee7b2c5520df5d6ef7c9c604e5e4bc092d49c0db3db916206ae","size":286852863}}
